import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef } from "react";
import "./style.scss";

const BasicModal = ({
  className,
  style,
  id,
  nestedGrid,
  disabled,
  onCloseClicked,
  children,
  withShadow,
  screenSettings,
  closeIconBackground,
}) => {
  const modalContentRef = useRef();

  // NOTE: Should not be the responsibility of the modal
  const close = useCallback(
    (event) => {
      if (event) {
        event.preventDefault();
      }

      window.history.replaceState(null, null, window.location.pathname);

      let elem = document.getElementById(id);
      if (typeof elem.scrollTo === "function") elem.scrollTo(0, 0);
      if (typeof elem.scrollTo === "undefined") elem.scrollTop = 0;
      elem.classList.add("hide-modal");
      elem.classList.remove("show-modal");
      document.body.classList.remove("show-modal");
    },
    [id]
  );

  const handleScroll = useCallback(() => {
    let elem = document.getElementById(id);
    if (elem === undefined) {
      return;
    }
    var rect = elem.getBoundingClientRect();

    if (
      rect.bottom - 299 >
      modalContentRef.current.getBoundingClientRect().bottom
    ) {
      if (typeof elem.scrollTo === "function") elem.scrollTo(0, 0);
      if (typeof elem.scrollTo === "undefined") elem.scrollTop = 0;
      close();
    }
  }, [close, id]);

  const handleClick = () => {
    if (!disabled && onCloseClicked) {
      onCloseClicked();
    }
  };

  useEffect(() => {
    let elem = document.getElementById(id);
    if (elem && !disabled) {
      elem.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (elem) {
        elem.removeEventListener("scroll", handleScroll);
      }
    };
  }, [disabled, id, handleScroll]);

  const modalBodyClasses = classNames("basic-modal-content", {
    "full-height": screenSettings.fullHeight || screenSettings.fullScreen,
  });

  const modalWrapperClasses = classNames("basic-modal-wrapper", {
    "full-width": screenSettings.fullWidth || screenSettings.fullScreen,
    "full-height": screenSettings.fullHeight || screenSettings.fullScreen,
  });

  const modalMaskClasses = classNames("basic-modal-mask", "grid", className);
  const modalClasses = classNames("basic-modal", {
    "full-screen": screenSettings.fullScreen,
  });
  const closeIconClasses = classNames("close", {
    "with-background": closeIconBackground,
  });
  return (
    <div
      className={modalMaskClasses}
      style={style}
      id={id}
      onClick={(event) => handleClick(event)}
    >
      <div className={modalWrapperClasses}>
        <div
          className={modalClasses}
          onClick={(event) => event.stopPropagation()}
        >
          {!disabled && (
            <div className="basic-modal-header">
              <span
                className={closeIconClasses}
                onClick={(event) => handleClick(event)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  width="24"
                >
                  <path d="M0 0h24v24H0V0z" fill="none" />
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
                </svg>
              </span>
            </div>
          )}
          <div className={modalBodyClasses} ref={modalContentRef}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

BasicModal.propTypes = {
  className: PropTypes.string,
  style: PropTypes.string,
  id: PropTypes.string,
  nestedGrid: PropTypes.bool,
  disabled: PropTypes.bool,
  onCloseClicked: PropTypes.func,
  children: PropTypes.node,
  withShadow: PropTypes.bool,
  screenSettings: PropTypes.shape({
    fullWidth: PropTypes.bool,
    fullScreen: PropTypes.bool,
    fullHeight: PropTypes.bool,
  }),
  closeIconBackground: PropTypes.bool,
};

BasicModal.defaultProps = {
  gridType: "normal",
  closeIconBackground: false,
};

export default BasicModal;
